import React from 'react'
import LoaderDots from '../../../Modal/components/LoaderDots';
import Select from '../../../miscellaneous/CustomSelect/CustomSelect'

const getClassFileSelect = (state) => {
  let className = 'kml-input-form-bottons on-mouse-hover '
  if (state.punto) return className + 'green-background-color'
  else className = className + 'gray-background-color '
  if (state.puntoError) return className + 'border-error-color'
  return className
}

const getClassPinSelect = (state) => {
  let className = 'kml-input-form-bottons on-mouse-hover '
  if (state.hasPin) return className + 'green-background-color'
  else className = className + 'gray-background-color '
  if (state.hasPinError) return className + 'border-error-color'
  return className
}

const addPoinst = (props) => {
  const { state, changeAddSelect } = props
  return (
    <>
      <input
        id='pin-input-file'
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={props.fileChange}
      ></input>
      <div className='dots-height'>
        {state.loading && <LoaderDots />}
        {state.upload ? (state.uploadOk ? <div className='text-center green-color'>Cargado con exito</div> : <div className='text-center red-color'>Error en la acción</div>) : <></>}
      </div>
      <div className="search-container">
        <div className="kml-file-input-form">
          <div className={(state.pinTextError && !state.pinText) ? 'kml-container-input border-error-color' : 'kml-container-input'}>
            <input
              placeholder='Nombre pin'
              type="text"
              className="kml-input"
              value={state.pinText}
              onChange={props.handlerText}
            />
          </div>
          <div onClick={props.fileSelect} className={getClassPinSelect(state)} title={state.pinName} >
            <i className="fas fa-map-marker-alt"></i>
          </div>
          <div className='flex-center' >
            <canvas id='canvas-pin' width='35' ></canvas>
          </div>
          <div onClick={props.saveCustomPin} className='kml-input-form-bottons primary-background-color on-mouse-hover'>
            <i className="fas fa-save"></i>
          </div>
        </div>
      </div>
      <div className="search-container">
        <div className="kml-file-input-form">
          <Select placeholder='Seleccione pin' options={state.pines} change={changeAddSelect} error={state.pinError} keyText='name' />
          <div className='icon-group-container'>
            {
              state.pin &&
              <img src={state.pin.icon} alt='icono' style={{ width: '35px', height: '40px' }} />
            }
          </div>
        </div>
      </div>
      <div className="search-container">
        <div className="kml-file-input-form">
          <div className={(state.nameError && !state.name) ? 'kml-container-input border-error-color' : 'kml-container-input'}>
            <input
              placeholder='Nombre punto'
              type="text"
              className="kml-input"
              value={state.name}
              onChange={props.handlerTextPunto}
            />
          </div>
          <div onClick={props.selectPointOnMap} className={getClassFileSelect(state)} title='Seleccionar punto' >
            <i className="fas fa-map-marked-alt"></i>
          </div>
          <div onClick={props.savePoint} className='kml-input-form-bottons primary-background-color on-mouse-hover'>
            <i className="fas fa-save"></i>
          </div>
        </div>
      </div>
    </>
  )
}

export default addPoinst;